import { Component } from '@angular/core';
import { IFloatingFilterAngularComp } from '@ag-grid-community/angular';
import { IFloatingFilterParams } from '@ag-grid-community/core';
import { FilterChangedEvent } from '@ag-grid-community/core/dist/esm/es6/events';

@Component({
    selector: 'app-default-floating-filter',
    templateUrl: './boolean-floating-filter.component.html',
    styleUrls: ['./boolean-floating-filter.component.scss'],
    standalone: false,
})
export class BooleanFloatingFilterComponent implements IFloatingFilterAngularComp {
    private params!: IFloatingFilterParams;
    public parentFilter: any;

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
    }

    showParentFilter() {
        this.params.showParentFilter();
    }

    onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
        if (parentModel?.values) {
            parentModel.values = parentModel?.values.sort();
        }
        this.parentFilter = parentModel;
    }
}
